import PhoneMockup from "./PhoneMockup";
import { Reveal, Chapter } from "./Reveal";

const SecondExample = () => (
  <section className="py-16 sm:py-24" data-testid="second-example">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Chapter num="05" label="Anywhere" />
      <div className="mt-10 flex flex-col items-center text-center">
        <Reveal>
          <h2 className="max-w-xl font-serif text-3xl font-medium leading-[1.12] tracking-tight text-guinep-ink sm:text-4xl">
            The same simple page, <em className="italic text-guinep-mid">wherever you work.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-guinep-mute sm:text-base">
            Crown & Coil Studio in Atlanta runs on the same page — Guinep Seed works wherever your
            clients find you.
          </p>
        </Reveal>
        <Reveal delay={0.15} className="relative mt-12">
          <div className="absolute left-1/2 top-1/2 -z-10 h-[105%] w-[125%] max-w-xl -translate-x-1/2 -translate-y-1/2 rounded-[4rem] bg-guinep-soft" />
          <PhoneMockup variant="locs" />
        </Reveal>
      </div>
    </div>
  </section>
);

export default SecondExample;
